/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component,
    ComponentFactoryResolver,
    Injector,
    ViewChild,
    ViewContainerRef, ViewEncapsulation
} from '@angular/core';
import {FcAgLoadingMaskComponent} from './fc-ag-loading-mask.component';

/**
 * Fc Loading Mask component with Angular.
 */
@Component({
    selector: 'fc-ag-loading-mask-holder',
    templateUrl: './fc-ag-loading-mask-holder.component.html',
    styleUrls: ['./fc-ag-loading-mask-holder.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcAgLoadingMaskHolderComponent {
    
    /**
     * Target viewContainer to insert loading mask.
     */
    @ViewChild('viewContainer', {read: ViewContainerRef, static: true}) viewContainer : any;
    
    /**
     * Component constructor.
     *
     * @param resolver ComponentFactoryResolver.
     * 
     * FcAgLoadingMaskComponent constructor.
     */
    constructor(private resolver: ComponentFactoryResolver) {
    }

    /**
     * Configures to show loading mask.
     */
    showLoadingMask(): void {
        const factory = this.resolver.resolveComponentFactory(FcAgLoadingMaskComponent);
        const injector = Injector.create({
            providers: [],
            parent: this.viewContainer.injector
        });
        const componentRef = factory.create(injector);
        this.viewContainer.insert(componentRef.hostView);
    }
    
    /**
     * Remove context instance.
     */
    hideLoadingMask(): void {
        this.viewContainer.remove(0);
    }
}
